import { render } from "./QuestionAlternatives.vue?vue&type=template&id=3e7e90a0&scoped=true&ts=true"
import script from "./QuestionAlternatives.vue?vue&type=script&lang=ts"
export * from "./QuestionAlternatives.vue?vue&type=script&lang=ts"

import "./QuestionAlternatives.vue?vue&type=style&index=0&id=3e7e90a0&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7e90a0"]])

export default __exports__